// extracted by mini-css-extract-plugin
export default {"container":"WhoAreWe_container__N8mes","contImage":"WhoAreWe_contImage__C6Bpl","contText":"WhoAreWe_contText__9f7gE"};